import { getAuthenticatedFetch } from "../../msal/authenticatedFetchService";
import { AppEnvironment } from "../types/AppEnvironment";

class EnvironmentService {
    async getEnvironments(): Promise<AppEnvironment[]> {
        const url = `${process.env.REACT_APP_SELF_SERVICE_PEOPLEPLANNER_API_URL}/Environments`;
        const response = await getAuthenticatedFetch()(url);
        if (!response.ok) {
            throw new Error(`Environments request failed with status ${response.status}`);
        }
        return await response.json();
    }
}

const environmentService = new EnvironmentService();

export default environmentService;
